import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import colorPicker from './colorPicker.vue';
import style from './style.vue';
import linkMiniPage from '@/views/components/linkForm/miniPage';
import commissionRoleLink from '@/views/components/linkForm/commissionRoleLink';
import { noop, numberToArray } from '@/util';

@Component({
  components: { colorPicker },
  mixins: [style],
})
export default class MiniPage extends Vue {
  @Prop({ default: () => {} })
    value: MiniPageBg;

  @Prop({ default: false })
    disabled: boolean;

  @Prop()
    fromPage: number;

  data: MiniPageBg = {};

  // 第一位为分销的数据 第二位为微页面的数据
  buttonHistory = {
    mini: null,
    distribution: null,
  };

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  // 选择分销角色
  selectCommissionRole() {
    commissionRoleLink.open({ sgId: Number(this.$route.params.id) }).then((result) => {
      this.buttonHistory.distribution = Object.assign({}, { pageId: result.id, linkDesc: `${result.id}+${result.name}`, page: 1 });
      this.data.desc.buttonInfo.pageInfo = this.buttonHistory.distribution;
    }, noop);
  }

  selectChange(val) {
    this.data.desc.buttonInfo.pageInfo = { page: val, pageId: 0, linkDesc: '' };
  }

  render(h) {
    const miniPageLinkMiniPage = () => {
      if (this.disabled) {
        return;
      }
      linkMiniPage.open({ sgId: Number(this.$route.params.id), siteId: Number(this.$route.params.siteId) }).then((result) => {
        this.buttonHistory.mini = Object.assign({}, { pageId: result.id, linkDesc: `${result.id}+${result.name}`, page: 4 });
        this.data.desc.buttonInfo.pageInfo = this.buttonHistory.mini;
      }, noop);
    };
    const delLink = () => {
      this.data.desc.buttonInfo.pageInfo.linkDesc = '';
      this.data.desc.buttonInfo.pageInfo.pageId = 0;
      this.$forceUpdate();
    };
    return (
      <div class="mini-page-edit">
        <el-form props={{ model: this.data }} label-width="0" ref="form" inline-message disabled={this.disabled}>
          <p class="blockTitle center-text-title">微页面名称</p>
          <el-form-item prop="desc.pageName" rules={{ required: true, message: '请输页面名称', trigger: 'blur' }} show-message={false} class="el-form-item-bottom-space">
            <el-input maxlength="20" show-word-limit v-model={this.data.desc.pageName}></el-input>
          </el-form-item>
          <p class="blockTitle center-text-title">页面底色</p>
          <colorPicker v-model={this.data.desc.val} disabled={this.disabled} />
          <p class="blockTitle center-text-title">按钮颜色</p>
          <el-form-item prop="desc.buttonInfo.buttonVal" rules={{ required: true, message: '请选择按钮颜色', trigger: 'change' }} class="button-bg-color">
            <colorPicker v-model={this.data.desc.buttonInfo.buttonVal} disabled={this.disabled} />
          </el-form-item>
          <p class="blockTitle center-text-title">按钮文字颜色</p>
          <el-form-item prop="desc.buttonInfo.textColor" rules={{ required: true, message: '请选择按钮文字颜色', trigger: 'change' }} class="button-text-color">
            <colorPicker v-model={this.data.desc.buttonInfo.textColor} disabled={this.disabled} />
          </el-form-item>
          <p class="blockTitle center-text-title">按钮文字</p>
          <el-form-item prop="desc.buttonInfo.content" rules={{ required: true, message: '请输入按钮文字', trigger: 'change' }} show-message={false} class="el-form-item-bottom-space">
            <el-input v-model={this.data.desc.buttonInfo.content} maxlength="10" show-word-limit></el-input>
          </el-form-item>
          <p class="blockTitle center-text-title">按钮动作</p>
          <el-form-item
            prop={`desc.buttonInfo.pageInfo.page${this.data.desc.buttonInfo.pageInfo.page === 4 ? 'Id' : ''}`}
            rules={{ required: true, message: '请选择链接微页面', trigger: 'change' }}
            class={{
              'el-form-item-bottom-space': true,
              'mini-link-require': this.data.desc.buttonInfo.pageInfo.page === 4 && !this.data.desc.buttonInfo.pageInfo.pageId,
            }}>
            <el-select v-model={this.data.desc.buttonInfo.pageInfo.page} placeholder="请选择" class="wid-70" onChange={val => this.selectChange(val)}>
              {(this.fromPage === 3 || this.fromPage === 9) && <el-option label="申请分销角色" value={1}></el-option>}
              <el-option label="加入会员" value={2}></el-option>
              <el-option label="返回上一页" value={3}></el-option>
              <el-option label="微页面" value={4}></el-option>
              {/* <el-option label="小程序首页" value={5}></el-option> */}
            </el-select>
            {!this.disabled && (
              <span>
                {this.data.desc.buttonInfo.pageInfo.page === 4 && (
                  <span class={['scopeSpan button-url', this.disabled && 'disabled']} onClick={miniPageLinkMiniPage.bind(this, this.data)}>
                    请选择
                  </span>
                )}
                {this.data.desc.buttonInfo.pageInfo.page === 1 && (
                  <span class="scopeSpan button-url" onClick={this.selectCommissionRole.bind(this)}>
                    请选择
                  </span>
                )}
              </span>
            )}
            {(this.data.desc.buttonInfo.pageInfo.page === 1 || this.data.desc.buttonInfo.pageInfo.page === 4) && this.data.desc.buttonInfo.pageInfo.linkDesc && (
              <div class="link-name">
                {this.data.desc.buttonInfo.pageInfo.linkDesc}
                {!this.disabled && (
                  <span class="x-del-icon" onClick={delLink.bind(this)}>
                    X
                  </span>
                )}
              </div>
            )}
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model={this.data.desc.showButton}>底部显示按钮</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
